export default "__VITE_ASSET__548338d4__"